import { render, staticRenderFns } from "./warrantyRef.pug?vue&type=template&id=5d2bc600&lang=pug&"
import script from "./warrantyRef.js?vue&type=script&lang=js&"
export * from "./warrantyRef.js?vue&type=script&lang=js&"
import style0 from "./warrantyRef.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2bc600')) {
      api.createRecord('5d2bc600', component.options)
    } else {
      api.reload('5d2bc600', component.options)
    }
    module.hot.accept("./warrantyRef.pug?vue&type=template&id=5d2bc600&lang=pug&", function () {
      api.rerender('5d2bc600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warrantyLayout/components/warrantyRef/index.vue"
export default component.exports